/**
 * 设计系统颜色常量
 * 用于 JS 中需要动态引用颜色的场景（如 style 对象中的动态 color）
 * CSS 中应优先使用 var(--color-xxx)
 */
export const COLORS = {
  primary: '#1890ff',
  success: '#52c41a',
  warning: '#faad14',
  error: '#ff4d4f',
  purple: '#722ed1',
  cyan: '#13c2c2',
  cyanLight: '#36cfc9',
  lime: '#73d13d',

  white: '#fff',
  bgLayout: '#f0f2f5',
  bgLight: '#f0f5ff',
  textDark: '#001529',
  textSecondary: '#8c8c8c',
  borderLight: '#d9d9d9',
  textMuted: '#bfbfbf',

  // 灰色系列
  gray100: '#f5f5f5',
  gray200: '#f0f0f0',
  gray400: '#595959',
  gray500: '#666',
  gray600: '#262626',

  // 浅色语义背景
  bgPrimaryLight: '#e6f7ff',
  bgSuccessLight: '#f6ffed',
  bgPurpleLight: '#f9f0ff',

  // 边框
  borderSuccess: '#b7eb8f',

  // 深色语义
  dangerDeep: '#cf1322',
  successDeep: '#3f8600',
  orange: '#fa8c16',
  magenta: '#eb2f96',
} as const;

/** Dashboard 统计卡片颜色 */
export const STAT_COLORS = {
  customers: COLORS.primary,
  proposals: COLORS.success,
  activeProposals: COLORS.warning,
  knowledge: COLORS.purple,
} as const;

/** 订阅计划颜色 */
export const PLAN_COLORS: Record<string, string> = {
  Free: COLORS.textSecondary,
  Starter: COLORS.primary,
  Professional: COLORS.purple,
  Enterprise: COLORS.warning,
};

/** 漏斗图颜色 */
export const FUNNEL_COLORS = [COLORS.primary, COLORS.cyanLight, COLORS.lime, COLORS.warning];

/** 支付方式品牌色 */
export const PAYMENT_COLORS = {
  alipay: '#1677ff',
  wechat: '#07c160',
} as const;

/** 渐变色 */
export const GRADIENTS = {
  sidebar: 'linear-gradient(180deg, #001529 0%, #002140 100%)',
  settings: 'linear-gradient(135deg, #1890ff 0%, #36cfc9 100%)',
  reference: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
} as const;
